<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div
        v-show="$route.path == '/Maintain/QIJob'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fas fa-wrench"></i>
            </span>
            <h3 class="kt-portlet__head-title">ค้นหาใบงานช่างซ่อม</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <label>ค้นหาเลขที่ใบงาน:</label>
                  <input v-model="qiKeyword" type="text" class="form-control" placeholder="ค้นหาจาก เลขที่ใบงาน"/>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group ">
                  <label class="label">วันที่สร้าง(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateStart"
                      name="jobsDateStart"
                      ref="jobsDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label class="label">วันที่สร้าง(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateEnd"
                      name="jobsDateEnd"
                      ref="jobsDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <label>สถานะใบงาน:</label>
                  <treeselect v-model="qiStatusCode" :multiple="true" :options="qiStatusCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label>ประเภทใบงาน:</label>
                  <treeselect v-model="qiTypeCode" :multiple="true" :options="qiTypeCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label class="label">ชื่อช่าง:</label>
                  <treeselect
                      v-model="qiUserId"
                      :multiple="true"
                      :load-options="LoadUsersIdOptions"
                      :async="true"
                      v-on:open="reLoadUsersIdOptions"
                      v-on:select="ClearAfterselect"
                      placeholder="กรุณาเลือก"
                      :cacheOptions="true"
                      ref="qiUserId"
                    />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label>BARCODE :</label>
                  <input v-model="qiOldBarcode" type="text" class="form-control" placeholder="BARCODE"/>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า:</label>
                  <treeselect id="qiProductCode" v-model="qiProductCode" :multiple="true" :options="qiProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
            </div>

            <div class="row mb-3">
                <div class="col-xl-6">
                    <button type="submit" class="btn btn-primary">ค้นหา</button>
                    <button type="reset"
                            class="btn btn-secondary"
                            @click="formReset">
                        ล้างค่าทั้งหมด
                    </button>
                </div>
                <div class="col-xl-6 text-right"
                     >
                    <button class="btn btn-outline-primary"
                            @click="exportExcel"
                            type="button">
                        <span>
                            <i class="fas fa-file-export"></i><span>Export Excel</span>
                        </span>
                    </button>
                </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped table-bordered table-hover table-checkable"
                id="qiJobsTable" style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all">เลขที่ใบงาน</th>
                    <th class="all">ประเภทใบงาน</th>
                    <th class="all">BARCODE</th>
                    <th class="all">จำนวน</th>
                    <th class="all">ชื่อสินค้า/อุปกรณ์</th>
                    <th class="all">สถานะการดำเนินการ</th>
                    <th class="all">วันที่สร้าง</th>
                    <th class="all">ชื่อช่าง</th>
                    <th class="all">ผู้ตรวจสอบยืนยัน</th>
                    <th class="all">คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>

          <div ref="barcodesModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">รายการ BARCODE</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <div class="kt-portlet__body">
                    <div class="kt-section kt-section--first">
                      <div class="row">
                        <div class="col-xl-12">
                          <div class="form-group">
                            <!--begin: Datatable -->
                            <table class="table-sm table-striped table-bordered table-hover" ref="barcodeLocalTable">
                              <thead>
                                <tr>
                                  <th class="all text-center">ลำดับ</th>
                                  <th class="all">BARCODE</th>
                                </tr>
                              </thead>
                            </table>
                            <!--end: Datatable -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import datepicker from "../../Shared/Datepicker";
import DatatableWarning from "../../Shared/DatatableWarning";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Action = Vue.extend({
  template: `
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
    <a href="#" @click.prevent="setValidate" v-if="data.showValidateButton" class="btn btn-sm btn-clean btn-icon"
      :title="data.isValidate ? 'ปิดใช้งานตรวจสอบเงื่อนไข' : 'เปิดใช้งานตรวจสอบเงื่อนไข'">
      <i class="fa" :class="{ 'fa-lock kt-font-success': data.isValidate, 'fa-unlock kt-font-danger': !data.isValidate }"></i>
    </a>
    <a href="#" @click.prevent="detailQi" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon">
      <i class="fa fa-search"></i>
    </a>
    <a href="#" @click.prevent="editQi" v-if="data.showEditButton" title="แก้ไขข้อมูล" class="btn btn-sm btn-clean btn-icon">
      <i class="fa fa-edit kt-font-warning"></i>
    </a>
    <a href="#" @click.prevent="remove" v-if="data.showCancelButton" class="btn btn-sm btn-clean btn-icon" title="ยกเลิกใบงาน">
      <i class="fa fa-trash-alt kt-font-danger"></i>
    </a>
  </div>`,
  methods: {
    

    detailQi: function() {
      router.push({
        path: `/Maintain/QIJob/Detail/${this.data.qiJobId}`,
      });
    },
    editQi: function() {
      if (this.data.qiTypeCode == "JOB_QI_TYPE_DRAWBACK") {
        router.push({
          path: `/Maintain/QIJob/EditDrawback/${this.data.qiJobId}`,
        });
      } else if (this.data.qiTypeCode == "JOB_QI_TYPE_REPAIR") {
        router.push({
          path: `/Maintain/QIJob/EditRepair/${this.data.qiJobId}`,
        });
      }
    },
    setValidate: function() {
      let self = this;
      if (this.data.isValidate) {
        Swal.fire({
          title: "คำสั่งปิดการตรวจสอบเงื่อนไขของเครื่อง หรืออุปกรณ์",
          type: "warning",
          html:
            "กรุณายืนยันคำสั่งปิดการตรวจสอบสถานะ,ประเภทอุปกรณ์,ที่ตั้ง<br>BARCODE ของใบงาน <strong>" +
            this.data.qiJobNumber +
            "</strong>",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            self.doSetValidate();
          }
        });
      } else {
        Swal.fire({
          title: "คำสั่งเปิดการตรวจสอบเงื่อนไขของเครื่อง หรืออุปกรณ์",
          type: "warning",
          html:
            "กรุณายืนยันคำสั่งเปิดการตรวจสอบสถานะ,ประเภทอุปกรณ์,ที่ตั้ง<br>BARCODE ของใบงาน <strong>" +
            this.data.qiJobNumber +
            "</strong>",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            self.doSetValidate();
          }
        });
      }
    },
    doSetValidate: function() {
      let self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });
      axios
        .post("/Api/QIJobs/SetValidate", {
          qiJobId: this.data.qiJobId,
          isValidate: !this.data.isValidate,
        })
        .then(function(response) {
          if (response.data.status) {
            self.$parent.reloadDataTable();
            Swal.fire("สำเร็จ", response.data.message, "success");
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
    remove: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งยกเลิกข้อมูลใบงาน",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งยกเลิกข้อมูลใบงาน <strong>" +
          this.data.qiJobNumber +
          "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังยกเลิกข้อมูล กรุณารอสักครู่...",
          });
          axios
            .post("/Api/QIJobs/Delete", {
              qiJobId: this.data.qiJobId,
            })
            .then(function(response) {
              if (response.data.status) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    datepicker,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      qiKeyword: null,
      qiOldBarcode: null,
      qiStatusCode: [],
      qiStatusCodeOptions: [],
      qiProductCode: null,
      qiProductCodeOptions: [],
      qiTypeCode: null,
      qiTypeCodeOptions: [],
      qiUserId: [],
      qiUserOptions: [],
      jobsDateStart: null,
      jobsDateEnd: null,
    };
  },
  methods: {
    LoadQiStatusCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=JOB_QI_STATUS", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.qiStatusCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadQiTypeCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=JOB_QI_TYPE", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.qiTypeCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreProductCodeOptions: function (e) {
      var self = this;
      var qiTypesArray = ['QiSpare', 'QiMachine', 'QiEquipment'];
      axios
        .post("/Api/QIJobs/ProductOption", {
          page: 0,
          limit: 1000,
          optionWithCode: true,
          qiTypes: qiTypesArray
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductCodeOptions = [];
            data.forEach((element) => {
              self.qiProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    reLoadUsersIdOptions: function(){
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/QIJobs/User/Options",{ 
            page: 1,
            search: searchQuery,
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
    formReset: function(e) {
      this.qiStatusCode = [
        "JOB_QI_STATUS_PENDING",
        "JOB_QI_STATUS_REPAIR_COMPLETED",
        "JOB_QI_STATUS_REQUEST_APPROVAL",
      ];
      this.qiKeyword = null;
      this.qiOldBarcode = null;
      this.qiProductCode = null;
      this.qiTypeCode = null;
      this.qiUserId = [];
      this.jobsDateStart = null;
      this.jobsDateEnd = null;
      $(`#jobsDateStart`).val("").trigger("change");
      $(`#jobsDateEnd`).val("").trigger("change");
      $(`#qiUserId`).val("").trigger("change");
      $(`#qiProductCode`).val("").trigger("change");
      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#qiJobsTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#qiJobsTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    showBarcodesModal(qiJobId) {
      axios.get(`/Api/QIJobs/BarcodesInfo/${qiJobId}`)
      .then(response => {
        const barcodes = response.data;
        const tableData = barcodes.map((barcode, index) => ({
          index: index + 1,
          barcodeNoOld: barcode.barcodeNoOld || '-'
        }));

        $(this.$refs.barcodeLocalTable).DataTable({
            data: tableData,
            language: {search: "ค้นหา",searchPlaceholder: "BARCODE",},
            columns: [
              { data: 'index', className: 'text-center' },
              { data: 'barcodeNoOld', className: 'text-center' }
            ],
            destroy: true
        });

        $(this.$refs.barcodesModal).modal('show');
      })
      .catch(error => {
        console.error('Error fetching barcodes:', error);
      });
    }
      ,
      exportExcel: function (e) {
          e.preventDefault();
          let self = this;

          KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
          });

          axios({
              method: "post",
              url: "/Api/QIJobs/ExportSearch",
              responseType: "arraybuffer",
              data: {
                  SearchKeyword: self.qiKeyword,
                  StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
                  EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
                  QIJobStatusCode: self.qiStatusCode,
                  QIJobTypeCode: self.qiTypeCode && self.qiTypeCode.length > 0
                      ? self.qiTypeCode
                      : ['JOB_QI_TYPE_EVALUATE', 'JOB_QI_TYPE_DRAWBACK', 'JOB_QI_TYPE_REPAIR'],
                  ProductCode: self.qiProductCode,
                  QIJobUsersId: self.qiUserId,
                  Barcode: self.qiOldBarcode,
              },
          })
              .then(function (response) {
                  if (response.status == "200") {
                      let filename = "";
                      let contentType = response.headers["content-type"];
                      let disposition = response.headers["content-disposition"];
                      //===Get Filename===
                      if (disposition && disposition.indexOf("attachment") !== -1) {
                          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                          var matches = filenameRegex.exec(disposition);
                          if (matches != null && matches[1]) {
                              filename = matches[1].replace(/['"]/g, "");
                          }
                      }
                      //Save file
                      let blob = new Blob([response.data], { type: contentType });
                      let link = document.createElement("a");
                      link.href = window.URL.createObjectURL(blob);
                      link.download = decodeURIComponent(filename);
                      link.click();
                  } else if (response.status == "204") {
                      Swal.fire(
                          "ไม่พบข้อมูล",
                          "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
                          "warning"
                      );
                  }
              })
              .catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
              })
              .then(function () {
                  KTApp.unblockPage();
              });
      }

  },
  async mounted() {
    let self = this;
    self.qiStatusCode = [
      "JOB_QI_STATUS_PENDING",
      "JOB_QI_STATUS_REPAIR_COMPLETED",
      "JOB_QI_STATUS_REQUEST_APPROVAL",
    ];
    self.LoadQiStatusCodeOptions();
    self.LoadQiTypeCodeOptions();
    self.LoadreProductCodeOptions();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateStart).on("changeDate", function(e) {
      self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateEnd).on("changeDate", function(e) {
      self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#qiJobsTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/QIJobs/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              SearchKeyword: self.qiKeyword,
              StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
              EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
              QIJobStatusCode: self.qiStatusCode,
              QIJobTypeCode: self.qiTypeCode && self.qiTypeCode.length > 0 
                ? self.qiTypeCode 
                : ['JOB_QI_TYPE_EVALUATE', 'JOB_QI_TYPE_DRAWBACK', 'JOB_QI_TYPE_REPAIR'],
              ProductCode: self.qiProductCode,
              QIJobUsersId: self.qiUserId,
              Barcode: self.qiOldBarcode,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [30, 50, 100],
        pageLength: 30,
        language: {lengthMenu: "Display _MENU_",},

        // Order settings
        order: [[6, "desc"]],
        columns: [
          {
            data: "qiJobNumber",
            className: "text-center",
            render: function(data, type, full, meta) {
              return data ? data : '-';
            },
          },
          {
            data: "qiTypeName",
            className: "text-center",
            render: function(data, type, full, meta) {
              let additionalText = '';
              if (full.qiTypeCode == "JOB_QI_TYPE_DRAWBACK" && full.finishedDate != null) {
                if (full.qiSubType === 1) {
                  additionalText = ' <br><span>(เบิก)</span>';
                } else {
                  additionalText = ' <br><span>(คืน)</span>';
                }
              } else if (full.qiTypeCode == "JOB_QI_TYPE_REPAIR" && full.finishedDate != null) {
                if (full.qiAreaPlant) {
                  additionalText = ' <br><span>(คลังสินค้า)</span>';
                } else {
                  additionalText = ' <br><span>(ตัวแทน)</span>';
                }
              }
              return data ? data + additionalText : '-';
            },
          },
          {
            data: "barcodeInfo",
            className: "text-center",
            render: function(data, type, full, meta) {
              if ((full.qiTypeCode === 'JOB_QI_TYPE_EVALUATE' || full.qiTypeCode === 'JOB_QI_TYPE_REPAIR') && full.qiSubType === 1) {
                if (data && data.length > 0) {
                  return data[0].barcodeNoOld ? data[0].barcodeNoOld : '-';
                }
              } else if ((full.qiTypeCode === 'JOB_QI_TYPE_EVALUATE' || full.qiTypeCode === 'JOB_QI_TYPE_REPAIR') 
                  && full.qiSubType === 2
                  && full.barcodeInfo && full.barcodeInfo.length > 0 && full.barcodeInfo[0].barcodeId != null
              ) {
                return `<button
                        type="button"
                        class="btn btn-outline-hover-info btn-elevate btn-circle btn-icon"
                        title="แสดงรายการ BARCODE"
                        data-qijob-id="${full.qiJobId}"
                      >
                        <i class="text-info la la-list"></i>
                      </button>`;
              }
              return '-';
            },
          },
          {
            data: "amount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.qiTypeCode == "JOB_QI_TYPE_DRAWBACK") {
                  //return full.sumItems ? full.sumItems : '-';
                  if (!full.sumItems) return '-';
                  return Number(full.sumItems).toLocaleString('en-US');
              } else {

                  //return data ? data : '-';
                  if (!data) return '-';
                  return Number(data).toLocaleString('en-US');
              }
            },
          },
          {
            data: "materialNameShow",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && full.items && full.items.length > 0) {
                let displayItems = full.items.slice(0, 2).map(item => {
                  return item.materialName + ' [' + item.materialCode + ']';
                }).join(',<br> ');
                // เพิ่มไอคอนแว่นขยายเพื่อดูเพิ่มเติม
                let expandIcon = full.items.length > 2 
                  ? '<a href="/Maintain/QIJob/Detail/' + full.qiJobId + '" class="btn btn-link btn-sm px-0 py-0"><i class="fa fa-search"></i></a>' 
                  : '';
                return `${displayItems} ${full.items.length > 2 ? '...' : ''} ${expandIcon}`;
              } else {
                if ((full.qiTypeCode === 'JOB_QI_TYPE_EVALUATE' || full.qiTypeCode === 'JOB_QI_TYPE_REPAIR') && full.qiSubType === 1) {
                  if (full.barcodeInfo && full.barcodeInfo.length > 0) {
                    let firstBarcode = full.barcodeInfo[0];
                    return firstBarcode.barcodeProductName ? `${firstBarcode.barcodeProductName} [${firstBarcode.barcodeProductCode}]` : '-';
                  }
                  return '-';
                }
                return data ? data : '-';
              }
            },
          },
          {
            data: "qiStatusName",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.qiStatusCode == "JOB_QI_STATUS_PENDING") {
                return (
                  '<span><i class="fa fa-sync-alt"></i> ' + data + "</span>"
                );
              }else if (full.qiStatusCode == "JOB_QI_STATUS_SUCCESS" && full.qiTypeCode == "JOB_QI_TYPE_EVALUATE") {
                let additionalText = '';
                if (full.evalFlag === 1) {
                  additionalText = ' <br><span class="text-danger">(ซ่อมไม่ได้)</span>';
                } else if (full.evalFlag === 2) {
                  additionalText = ' <br><span class="text-success">(ซ่อมได้)</span>';
                } else if (full.evalFlag === 3) {
                  additionalText = ' <br><span class="text-warning">(ไม่เสีย)</span>';
                }
                return (
                  '<span><i class="fa fa-check-circle"></i> ' + data + additionalText + "</span>"
                );
              }else if (full.qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
                return (
                  '<span><i class="fa fa-check-circle"></i> ' + data + "</span>"
                );
              }
              else if (full.qiStatusCode == "JOB_QI_STATUS_REQUEST_APPROVAL") {
                return (
                  '<span><i class="fa fa-file-signature"></i> ' + data + "</span>"
                );
              }else if (full.qiStatusCode == "JOB_QI_STATUS_REPAIR_COMPLETED") {
                return (
                  '<span><i class="fa fa-check"></i> ' + data + "</span>"
                );
              }else if (full.qiStatusCode == "JOB_QI_STATUS_CANCEL") {
                return (
                  '<span class="text-danger"><i class="fa fa-ban"></i> ' + data + "</span>"
                );
              }
              return data ? data : '-';
            },
          },
          {
            data: "CreatedDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.createdDateFormat;
            },
          },
          { data: "createdUserName", className: "text-center" },
          { 
            data: "confirmedUserName",
            className: "text-center",
            render: function(data, type, full, meta) {
              return data ? data : '-';
            },
          },
          {
            data: "qiJobId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showValidateButton = false;
            if (data.qiStatusCode == "JOB_QI_STATUS_PENDING" && 
              (data.qiTypeCode =="JOB_QI_TYPE_EVALUATE" || data.qiTypeCode =="JOB_QI_TYPE_REPAIR") &&
              self.$root.canShow(["OFFICER_QIMAINTAIN"])
            ) {
              data.showValidateButton = true;
            }

            data.showEditButton = false;
            if (((data.qiStatusCode == "JOB_QI_STATUS_REQUEST_APPROVAL" || data.qiStatusCode == "JOB_QI_STATUS_SUCCESS") && 
                  data.qiTypeCode == "JOB_QI_TYPE_DRAWBACK" && self.$root.canShow(["OFFICER_QIMAINTAIN"])) ||
                ((data.qiStatusCode == "JOB_QI_STATUS_REPAIR_COMPLETED" || data.qiStatusCode == "JOB_QI_STATUS_SUCCESS") && 
                  data.qiTypeCode == "JOB_QI_TYPE_REPAIR" && self.$root.canShow(["OFFICER_QIMAINTAIN"]))
            ) {
              data.showEditButton = true;
            }

            if (data.isUnrepair) {
              data.showEditButton = false;
            }

            data.showCancelButton = false;
            if ((data.qiStatusCode == "JOB_QI_STATUS_PENDING" || data.qiStatusCode == "JOB_QI_STATUS_REQUEST_APPROVAL") &&
              self.$root.canShow(["OFFICER_QIMAINTAIN"])
            ) {
              data.showCancelButton = true;
            }

            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });

      $('#qiJobsTable').on('click', 'button', function() {
        const qiJobId = $(this).data('qijob-id');
        self.showBarcodesModal(qiJobId);
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/QIJob/QIJobList.vue